import {
  FETCH_QUOTE_TO_ORDER_BEGIN,
  FETCH_QUOTE_TO_ORDER_SUCCESS,
  FETCH_QUOTE_TO_ORDER_FAILURE,
  FETCH_QUOTE_TO_ORDER_BAD_REQUEST_FAILURE,
} from "../actions/ttQuoteToOrderActions";
import { ITtQuote } from "../api/model/tt-quote-to-order";
import { TtGetQuoteToOrderRequest } from "../api/requests/tt-get-quote-to-order-request";

export interface IError {
  message: string;
}

interface IInitialState {
  quotes: Array<ITtQuote>;
  totalNoOfQuotes: number;
  merge: boolean;
  loading: boolean;
  error: Array<IError> | IError;
  request: TtGetQuoteToOrderRequest;
  badRequestError: IError;
}

const initialState: IInitialState = {
  quotes: [],
  totalNoOfQuotes: 0,
  merge: false,
  loading: false,
  error: null,
  request: null,
  badRequestError: null,
};

export default function ttQuoteToOrderReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_QUOTE_TO_ORDER_BEGIN:
      return {
        ...state,
        loading: true,
        quotes: [],
        merge: true,
        error: null,
        badRequestError: null,
        request: action.payload,
      };
    case FETCH_QUOTE_TO_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        quotes: action.payload.ttQuoteToOrderResponse.quotes || [],
        totalNoOfQuotes:
          action.payload.ttQuoteToOrderResponse.totalNoOfQuotes || 0,
        merge: false,
      };
    case FETCH_QUOTE_TO_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        errors: action.payload.errors,
        quotes: [],
        merge: false,
      };
    case FETCH_QUOTE_TO_ORDER_BAD_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        badRequestError: action.payload.errors,
        quotes: [],
        merge: false,
        totalNoOfQuotes: 0,
      };
    default:
      return state;
  }
}
